import React from 'react';

export interface WelcomeBannerProps {
  logoUrl?: string | null;
  botName?: string | null;
}

/**
 * Welcome banner shown at the top of the messages container. Renders the chat
 * connection's logo image and bot name. Scrolls with the conversation — once
 * messages fill the viewport, the banner moves out of view.
 *
 * Renders nothing if both props are empty.
 */
export const WelcomeBanner: React.FC<WelcomeBannerProps> = ({ logoUrl, botName }) => {
  if (!logoUrl && !botName) {
    return null;
  }
  return (
    <div className="omq-chatbot-welcome-banner" aria-hidden="true">
      {logoUrl && (
        <img src={logoUrl} alt="" className="omq-chatbot-welcome-banner__logo" />
      )}
      {botName && (
        <div className="omq-chatbot-welcome-banner__name">{botName}</div>
      )}
    </div>
  );
};
